import { ajax } from 'rxjs/ajax';

export const getRouteById = (id: string) => {
    return ajax({
        method: 'GET',
        url: `${process.env.CMFA_APP_PLATFORM_ORDER_CAPTOR_URL}/routes/${id}`,
        crossDomain: true,
    });
};
